module.exports = __webpack_public_path__ + "img/maid_experience.fd38056b.png";